module.exports = __webpack_public_path__ + "media/cycles-games-over@md-c745ce588dc356afce8e51fc86e44e2a.jpg";